import { useProductOptionsForQueryParams } from '@bluheadless/ui-logic/src/hooks/product/useProductOptionsForQueryParams'
import { useUpdateQueryParams } from '@bluheadless/ui-logic/src/hooks/useUpdateQueryParams'
import { useProductContext } from '@bluheadless/ui-logic/src/providers/product'

const ProductOptionsToUrlParams = () => {
	const productContextValue = useProductContext()

	const [{ product = {}, selectedOptionsIdsValues } = {}] = productContextValue ?? []
	const { configurableOptions = [], bundleOptions = [] } = product

	const productOptionsForQueryParams = useProductOptionsForQueryParams({
		selectedOptionsIdsValues,
		configurableOptions,
		bundleOptions,
	})

	useUpdateQueryParams({ params: productOptionsForQueryParams })

	return null
}

export default ProductOptionsToUrlParams
